import classnames from 'classnames';
import React, { Component } from 'react';
import { DEFAULT_LOCALE_CODE } from '../../constants';
import { Select } from '@nackle/origami';
import { getString } from '@nackle/intl-tools';

import './language-picker.less';

export default class languagePicker extends Component {

    updateLanguage = async( value, option ) => {
        const { updateLocale } = this.props;
        await updateLocale( value );
    };

    getLocales = () => {
        let formattedLocales;
        if ( this.props.locales && this.props.locales.length > 0 ) {
            const filteredLocales = this.props.locales.filter( locale => {
                return locale.code !== 'ar-SA' && locale.code !== 'id-ID';
            } );
            formattedLocales = filteredLocales.map( locale => {
                return ( {
                    label: locale.label,
                    value: locale.code
                } );
            } );

            formattedLocales.sort( function ( a, b ) {
                if ( a.label < b.label ) {
                  return -1;
                }
                if ( a.label > b.label ) {
                  return 1;
                }
                return 0;
              } );
            
            return formattedLocales;
        }
    };

    render() {
        let {
            className,
            updateLocale,
            defaultLocale,
            userSelectedLocale,
            ...props
        } = this.props;

        const options = this.getLocales();

        const locale = userSelectedLocale || defaultLocale || DEFAULT_LOCALE_CODE;

        return ( 
            <div className={ classnames( 'languagePickerContainer', className ) } { ...props }>
                <Select
                    suffixIcon={ <DownArrow/> }
                    aria-label={ getString( 'languagePicker.input.languagePickerAriaLabel' ) }
                    size="large"
                    onChange={ this.updateLanguage }
                    options={ options }
                    value={ locale }
                    bordered={ false }
                />
            </div>
        );
    }
}

export const DownArrow = ( { originalSize, style, svgRef, className, ...props } ) => (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.38411 5.53907C5.18421 5.77895 4.81579 5.77894 4.61589 5.53907L0.68341 0.820092C0.412023 0.494428 0.643602 5.24964e-08 1.06752 8.7074e-08L8.93248 7.28592e-07C9.3564 7.63169e-07 9.58798 0.494429 9.31659 0.820093L5.38411 5.53907Z" fill="#3F8CFF"/>
    </svg>
);
